import { EmployeeProjectAction } from '@/types/project';

export const MEMBER_EVENTS = {
  INVITED: 'Member invited',
  LEFT: 'Member left',
  REMOVED: 'Member removed',
  UPDATED: 'Member updated',
  RE_INVITED: 'Member re-invited',
};

// Action label mapping for member operations
export const MEMBER_ACTION_LABEL_MAP: Record<EmployeeProjectAction, string> = {
  [EmployeeProjectAction.INVITE_MEMBER]: 'Member invited',
  [EmployeeProjectAction.CHANGE_ROLE_MEMBER]: 'Role changed',
  [EmployeeProjectAction.LEAVE_MEMBER]: 'Member left',
  [EmployeeProjectAction.REMOVE_MEMBER]: 'Member removed',
  [EmployeeProjectAction.RESUME_MEMBER]: 'Member resumed',
};

// Success message mapping for member operations
export const MEMBER_ACTION_SUCCESS_MESSAGE_MAP: Record<
  EmployeeProjectAction,
  string
> = {
  [EmployeeProjectAction.INVITE_MEMBER]:
    'has been successfully invited to the project',
  [EmployeeProjectAction.CHANGE_ROLE_MEMBER]:
    'role has been updated successfully',
  [EmployeeProjectAction.LEAVE_MEMBER]:
    'has been marked as left from the project',
  [EmployeeProjectAction.REMOVE_MEMBER]:
    'has been permanently removed from the project',
  [EmployeeProjectAction.RESUME_MEMBER]:
    'has been successfully resumed in the project',
};

export const EMPLOYEE_INFO_SAVED = (key?: string) =>
  `Employee ${key || 'information'} saved`;
